


















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { PageTitle } from '@questelservices/common-vue';
import { DxButton, DxPopup, DxLoadIndicator } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import { MatterWorkDto } from '../models/matter-work/MatterWorkDto';
import { MatterWorkMatterDto } from '../models/matter-work/MatterWorkMatterDto';
import MatterWorkLineItems, { MatterWorkLineItemsDialogState } from '../components/matter-work/matter-work-line-items.vue';
import { MatterWorkTypeEnum } from '../models/matter-work/MatterWorkTypeEnum';
import MatterTotals from '../components/matter-work/matter-totals.vue';
import { PhaseTypeDto } from '../models/PhaseTypeDto';
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import { KeyMap } from '@/models/KeyMap';
import { PhaseNames } from '@/models/PhaseNames';
import OrderSetupDialog from '../components/matter-work/phase-assignment_order-setup-dialog.vue';
import { UserSetting, UserSettingReportName, UserSettingName, OrderingMethod } from '@/models/UserSetting';
import FilingType from '../components/filing-type.vue';
import { ChangeFilingTypeDto, FilingTypeDto } from '../models/FilingTypeDto';
import { FilingTypeService } from '../service/FilingTypeService';
import { UserSettingFilter } from '@/models/UserSettingFilter';
import { UserService } from '@/service/UserService';
import _, { orderBy, update } from 'lodash';
import { FeeSheetRuleDto } from '@/models/Fees/FeeSheetRuleDto';
import notify from 'devextreme/ui/notify';
import { alert } from "devextreme/ui/dialog"
import { BatchService } from '@/service/BatchService';
import { FeeBudgetRuleDto } from '@/models/fee-budgets/FeeBudgetRuleDto';
import MatterWorkNavigator from '../components/matter-work/matter-work-navigator.vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import MatterWorkModule from '@/store/MatterWorkModule';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

@Component({
  components: {
    PageTitle,
    DxButton,
    MatterTotals,
    MatterWorkLineItems,
    OrderSetupDialog,
    FilingType,
    DxPopup,
    DxLoadIndicator,
    MatterWorkNavigator
  },
  beforeRouteLeave: function(to,from,next) {
    let codingPage: PhaseAssignment = this as PhaseAssignment;
    codingPage.$destroy();
    next();
  }
})
export default class PhaseAssignment extends Vue {
  $refs: Vue['$refs'] & {
    matterWorkLineItems?: MatterWorkLineItems;
    matterWorkNavigation?: MatterWorkNavigator;    
  } = {};

  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  private filingTypeService: FilingTypeService = new FilingTypeService();
  private userService: UserService = new UserService();

  get lineItemDataGrid(): DevExpress.ui.dxDataGrid {
      return (((this.$refs.matterWorkLineItems as any).$refs.manualCodingDataGrid as any).$refs
                          .dxDataGrid as any).instance
  }

  private get matterWorkId(): Guid | undefined {
    return this.$route.params.id;
  }

  private get userReviewedMode(): boolean | undefined {
    if (this.matterWork) {
      return this.matterWork.UserReviewedMode;
    }
    else {
      return false;
    } 
  }

  private matterWork: MatterWorkDto | null = null;
  private phaseTypes: PhaseTypeDto[] = [];
  private filingTypes: FilingTypeDto[] = [];
  private feeSheetRules: FeeSheetRuleDto[] = [];
  private feeBudgetRules: FeeBudgetRuleDto[] = [];

  clientId: Guid = '';
  private gridRefresher: boolean = true;
  private gridRefreshTimeout: any = null;

  @Watch("selectedMatterId")
  gridRefresh() {
    this.gridRefresher = false;
    if(this.gridRefreshTimeout) {
      clearTimeout(this.gridRefreshTimeout);
    }
    this.gridRefreshTimeout = setTimeout(()=>{
      this.gridRefresher = true;
    }, 100);
  }
  matterWorkModule = getModule(MatterWorkModule, store);

  private get selectedMatterId() {
    return this.matterWorkModule.selectMatterId;
  }

  private get selectedMatter() {
    return this.matterWorkModule.selectMatter;
  }

  private get selectedFilingType(): FilingTypeDto | undefined {
    if(this.selectedMatter) {
      return this.filingTypes.find(t => t.FilingTypeId === this.selectedMatter!.FilingTypeId);
    }
  }

  private confirmAll: boolean = false;  

  get getClientId() { 
    if(this.selectedMatter) {
      return this.selectedMatter.ClientId;
    }
  }
  
  private allMattersConfirmed: boolean = false;
  private allMattersReviewed: boolean = false;

  // This gets the status of the left sidebar
  private get sidePanelIsOpen() {
    return (this.$root.$children[0].$children[1] as any).menuOpened;    
  }

  private isAutoSkip : boolean = false;

  @Watch('allMattersConfirmed')
  onAllMattersConfirmed() {
    // Only show dialog when all matters weren't originally 
    // confirmed and are now confirmed
    if (this.allMattersConfirmed) {
      this.showingReleaseMatters = true;
    }  
  }

  @Watch('selectedMatter')
  onSelectedMatterChanged() {
    this.linesSetByCodeAll = [];
  }

  @Watch('allMattersReviewed')
  onAllMattersReviewed() {
    if (this.allMattersReviewed && this.matterWork && this.matterWork.UserReviewedMode) {
      this.showingReleaseMatters = true;
    }  
  }

  private showingReleaseMatters: boolean = false;

  pageType: MatterWorkTypeEnum = MatterWorkTypeEnum.Coding;

  batchService: BatchService;
 
  get batchIdsOfCurrentBatch() {
    return this.matterWorkModule.activeBatches || [];
  }

  mounted() {

  }

  constructor() {
    super();
    this.batchService = new BatchService();
    
  }

  created() {
    document.addEventListener('keyup', this.onKeyup);
    this.loadData();
  }

  beforeDestroy() {
    if(this.$refs.matterWorkLineItems) {
      this.$refs.matterWorkLineItems.$destroy();
    }
    if(this.$refs.matterWorkNavigation) {
      this.$refs.matterWorkNavigation.$destroy();
    }

    this.gridRefresher=false;
    this.feeSheetRules.length=0;
    this.feeBudgetRules.length=0;
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup);
    this.matterWorkModule.setSelectedMatterId(null);
    this.matterWorkModule.setSelectedMatter(null);
    this.matterWorkModule.setActiveBatchIds([]);
  }

  onAutoSkipChanged(data: boolean) {
    this.isAutoSkip = data;
  }

  get isDialogOpen() {
    return this.showingSetupDialog || this.showingNotes || this.showingContextMenu || this.showingColumnChooser ||
      this.showingInfractions || this.showingInfractionsPopover || this.showingReleaseMatters || this.showingPhaseHistory ||
      this.showingUpdateCountry || this.showingUpdateMatterName;
  }

  onKeyup(event: KeyboardEvent) {
    if (this.isDialogOpen) {
      return;
    }

    //if target of event is a text editor disable keyboard shortcuts
    if ((event.target as any ).className == "dx-texteditor-input") {
      return;
    }

    event.preventDefault();
    
    if (event.ctrlKey) {
      switch (event.keyCode) {
        case KeyMap.one:
        case KeyMap.numPadOne:
          this.assignPhaseToSelection(PhaseNames.misc,event);
          break;
        case KeyMap.two:
        case KeyMap.numPadTwo:
          this.assignPhaseToSelection(PhaseNames.publication,event);
          break;
        case KeyMap.three:
        case KeyMap.numPadThree:
          this.assignPhaseToSelection(PhaseNames.postGrantReview,event);
          break;
        case KeyMap.four:
        case KeyMap.numPadFour:
          this.assignPhaseToSelection(PhaseNames.validation,event);
          break;
        case KeyMap.five:
        case KeyMap.numPadFive:
          this.assignPhaseToSelection(PhaseNames.pph,event);
          break;
        case KeyMap.six:
        case KeyMap.numPadSix:
          this.assignPhaseToSelection(PhaseNames.noveltySearch,event);
          break;
        case KeyMap.fSlash:
        case KeyMap.numPadFSlash:
          this.assignPhaseToSelection(PhaseNames.idsCopies,event);
          break;
      }
    } else {
      switch (event.keyCode) {
        case KeyMap.leftArrow:
          (this.$refs.matterWorkNavigation as any).prevCase();
          break;
        case KeyMap.rightArrow:
          (this.$refs.matterWorkNavigation as any).nextCase();
          break;
        case KeyMap.upArrow:              
          (this.$refs.matterWorkNavigation as any).prevActiveCase();
          break;
        case KeyMap.downArrow:                       
          (this.$refs.matterWorkNavigation as any).confirmAllMatters();
          break;
        case KeyMap.one:
        case KeyMap.numPadOne:
          this.assignPhaseToSelection(PhaseNames.drafting,event);
          break;
        case KeyMap.two:
        case KeyMap.numPadTwo:
          this.assignPhaseToSelection(PhaseNames.filing,event);
          break;
        case KeyMap.three:
        case KeyMap.numPadThree:
          this.assignPhaseToSelection(PhaseNames.exam,event);
          break;
        case KeyMap.four:
        case KeyMap.numPadFour:
          this.assignPhaseToSelection(PhaseNames.prosecution,event);
          break;
        case KeyMap.five:
        case KeyMap.numPadFive:
          this.assignPhaseToSelection(PhaseNames.grant,event);
          break;
        case KeyMap.six:
        case KeyMap.numPadSix:
          this.assignPhaseToSelection(PhaseNames.oneSixOneOneSixTwo,event);
          break;
        case KeyMap.seven:
        case KeyMap.numPadSeven:
          this.assignPhaseToSelection(PhaseNames.appeal,event);
          break;
        case KeyMap.eight:
        case KeyMap.numPadEight:
          this.assignPhaseToSelection(PhaseNames.subsequentApplications,event);
          break;
        case KeyMap.nine:
        case KeyMap.numPadNine:
          this.assignPhaseToSelection(PhaseNames.annuity,event);
          break;
        case KeyMap.fSlash:
        case KeyMap.numPadFSlash:
          this.assignPhaseToSelection(PhaseNames.ids,event);
          break;
        case KeyMap.period:
        case KeyMap.numPadPeriod:
          let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
          if (selectedRows.length === 1) {
            this.openNotes();
          } else if (selectedRows.length > 1) {
            notify('Cannot open notes with multiple lines selected.','info', 1000);
          }
          break;
      }
    }
  }

  async loadRequiredData() {
    this.phaseTypes = await this.client.get<PhaseTypeDto[]>('/api/phasetype/all');
    this.matterWork = await this.client.get<MatterWorkDto>(`/api/MatterWorks/${this.matterWorkId}`);
  }

  async loadData() {
    // Phase types and matters are required for the navigator / page to load, other data can be loaded asyncronously
    await this.loadRequiredData();
    
    this.filingTypeService.getTypes().then(types => {
      this.filingTypes = types;
    });

    this.getAutoskipPreference().then(preference => {
      this.isAutoSkip = preference;
    });

    this.client.get(`/api/MatterWorks/${this.matterWorkId}/fee-sheet-rules`).then(rules => {
      this.feeSheetRules = rules;
    });

    this.client.get<FeeBudgetRuleDto[]>(`/api/MatterWorks/${this.matterWorkId}/fee-budget-rules`).then(rules => {
      this.feeBudgetRules = rules;
    });
  }

  updateLineItems(lineItems: ManualCodeInvoiceLineItemDto[], skip: boolean = true): void {    
    if (this.$refs.matterWorkLineItems) {
      this.$refs.matterWorkLineItems.updateLineItems(lineItems);
    }

    this.checkAllLineItemsConfirmed(skip);
  }

  private linesSetByCodeAll: Guid[] = [];

  async assignPhaseToSelection(phaseTypeId: number | null, event: KeyboardEvent | null): Promise<void> {     
    let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
    let lineItemIds: Guid[] = [];

    // If no line items selected, assign phase to all line items in latest batch
    if (selectedRows.length === 0) {
      if (this.linesSetByCodeAll.length > 0) {
        lineItemIds = this.linesSetByCodeAll;
      } else if (this.$refs.matterWorkLineItems && this.$refs.matterWorkLineItems.activeBatchIds) {
        lineItemIds = this.$refs.matterWorkLineItems.lineItems
          .filter(li => this.batchIdsOfCurrentBatch.some(b => b === li.BatchId) && li.LastAssignedById == null)
          .map(li => li.InvoiceLineItemId);
        this.linesSetByCodeAll = lineItemIds;
      }

      if (this.$refs.matterWorkLineItems) {
        selectedRows = this.$refs.matterWorkLineItems.lineItems.filter(li => lineItemIds.some(id => li.InvoiceLineItemId == id));
      }      

    } else {
      this.linesSetByCodeAll = [];
      selectedRows.forEach(row => {
        lineItemIds.push(row.InvoiceLineItemId);
      });
    }

    if (lineItemIds.length) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.lineItemDataGrid.clearSelection();
             
      let oldRows: ManualCodeInvoiceLineItemDto[] = _.cloneDeep(selectedRows);

      let assignedPhaseTypeId = phaseTypeId == null ? -1 : phaseTypeId;
      let assignedPhaseName = phaseTypeId == null ? 'Unassigned' : this.phaseTypes.filter(p => p.PhaseTypeId == phaseTypeId)[0].PhaseName;      

      selectedRows.forEach(li => {
          li.AssignedPhaseTypeId = assignedPhaseTypeId;
          li.AssignedPhaseName = assignedPhaseName;
          li.Confirmed = true;
        });      

      let updatedMatter = this.selectedMatter;
      this.updateLineItems(selectedRows, false);
      this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);

      await this.client.getPostData<ManualCodeInvoiceLineItemDto[]>('/api/manualcoding/assignphase', {
        phaseTypeId: phaseTypeId,
        lineItems: lineItemIds
      })
      .then(results => {
        // update the line items with any additional information from the backend (LastAssignedById, ConfirmedById, etc)
        // only update the line items if the matter hasn't been changed after phase assignment
        if (this.selectedMatterId == updatedMatter!.MatterId) {
          this.updateLineItems(results, false);
          this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);
        }        
      })
      .catch(_ => {
        alert(`Error assigning phase to line item(s) for matter ${updatedMatter!.ClientMatterId}.`, "Error");
        if (this.selectedMatterId == updatedMatter!.MatterId) {
          //revert rows if an error occurs
          this.updateLineItems(oldRows, false);        
          this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);
        }        
      });
    }
  }

  setExemptRowToSelection(isExemptRow: boolean) {
    let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
    let lineItemIds: Guid[] = [];

    // If no line items selected, assign phase to all line items in latest batch
    if (selectedRows.length === 0) {     
      if (this.$refs.matterWorkLineItems && this.$refs.matterWorkLineItems.activeBatchIds) {
        let activeBatchIds = this.$refs.matterWorkLineItems.activeBatchIds;
        lineItemIds = this.$refs.matterWorkLineItems.lineItems
          .filter(li => activeBatchIds.some(b => b === li.BatchId))
          .map(li => li.InvoiceLineItemId);
      }
    } else {      
      selectedRows.forEach(row => {
        lineItemIds.push(row.InvoiceLineItemId);
      });
    }

    if (lineItemIds.length) {
      this.lineItemDataGrid.clearSelection();
      
      this.client.getPostData<ManualCodeInvoiceLineItemDto[]>('/api/manualcoding/updateexemptrow', {
        isExemptRow: isExemptRow,
        lineItems: lineItemIds
      }).then(results => {
        this.updateLineItems(results, false);
      });
    }
  }

  matterWorkLineItemsDialogStateChanged(e: MatterWorkLineItemsDialogState) {
    this.showingNotes = e.showingNotes;
    this.showingContextMenu = e.showingContextMenu;
    this.showingColumnChooser = e.showingColumnChooser;
    this.showingInfractions = e.showingInfractions;
    this.showingInfractionsPopover = e.showingInfractionsPopover;
    this.showingPhaseHistory = e.showingPhaseHistory;
    this.showingUpdateCountry = e.showingUpdateCountry;
    this.showingUpdateMatterName = e.showingUpdateMatterName;
  }

  confirmAllMatters() {  
    this.selectedMatter!.UserReviewed = true;
    let matterId = this.selectedMatterId;
    (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, true);
    if (this.userReviewedMode) {
      this.client.postJson(`/api/manualcoding/review-matter/${this.selectedMatterId}`, {} )
      .then(result => {
        if(result.Data === false) {
          (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
        }
      }).catch(x=>{
        (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
      }).finally(()=>{
        if((this.$refs.matterWorkNavigation as any).checkForRelease()) {
          this.allMattersReviewed = true;
        }
      }); 
    } 
    else {
      this.client.postJson(`/api/manualcoding/${this.selectedMatterId}/confirmall`, {      
      }).then(result => {      
        this.confirmAll = true;
        this.lineItemDataGrid.refresh();
        if(result.Data === false) {
          (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
        }
      }).catch(x=>{
        (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
      }).finally(()=>{
        if((this.$refs.matterWorkNavigation as any).checkForRelease()) {
          this.allMattersConfirmed = true;
        }
      });    
    }
  }    
      

  lineItemsLoaded(lineItems: ManualCodeInvoiceLineItemDto[]): void {    
    if (lineItems && lineItems.length) {
      if(this.selectedMatter) {
        this.selectedMatter.LineItems = lineItems;  
      }
      if (!this.userReviewedMode) {
        this.checkAllLineItemsConfirmed();      
      }       
    }
  }

  autoSkipPref: UserSettingFilter = {
            reportName: UserSettingReportName.UserPreference,
            name : UserSettingName.AutoSkip
        }
        
  getAutoskipPreference(): Promise<any> {
    return this.userService.getUserSettingsWithFilter(this.autoSkipPref)
            .then((result: UserSetting[]) => {
                let autoSkip = _.find(result, (item:UserSetting) => {
                                    return item.ReportName === UserSettingReportName.UserPreference &&
                                            item.Name === UserSettingName.AutoSkip;
                                }) || false;

                return (autoSkip ? autoSkip.Value == 'true': false);
            })
            .catch((err: any) => false)
  }

  checkAllLineItemsConfirmed(skip: boolean = true) {       
    let allPreviouslyConfirmed: boolean = this.selectedMatter!.AllLineItemsConfirmed;
    this.selectedMatter!.AllLineItemsConfirmed = this.selectedMatter!.LineItems.every(li => li.Confirmed);
    if(skip || this.isAutoSkip) {      
      this.autoskipIfFinalRowConfirmed(this.selectedMatter!.AllLineItemsConfirmed, allPreviouslyConfirmed);           
    }  
  }

  private autoskipIfFinalRowConfirmed(allConfirmed: boolean, allPreviouslyConfirmed: boolean): void {        
    if (!allPreviouslyConfirmed && allConfirmed && !this.userReviewedMode) {    
      this.selectedMatter!.UserReviewed = true;
      let matterId = this.selectedMatter!.MatterId;
      this.client.postJson(`/api/manualcoding/${this.selectedMatterId}/confirmall`, {} )
        .then(result => {
          (this.$refs.matterWorkNavigation as any).nextActiveCase();
          if(result.Data === false) {
            (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
          }
        }).catch(x=>{
          (this.$refs.matterWorkNavigation as any).confirmAuditMatter(matterId, false);
        }).finally(()=>{
          if((this.$refs.matterWorkNavigation as any).checkForRelease()) {
            this.allMattersReviewed = true;
          }
        });
    }
  }

  public showingSetupDialog: boolean = false;
  
  private showingNotes: boolean = false;
  private showingContextMenu: boolean = false;
  private showingColumnChooser: boolean = false;
  private showingInfractions: boolean = false;
  private showingInfractionsPopover: boolean = false;
  private showingPhaseHistory: boolean = false;
  private showingUpdateCountry: boolean = false;
  private showingUpdateMatterName: boolean = false;

  openSetupDialog(): void {
    this.showingSetupDialog = true;
  }

  hidingDialog() {
    this.showingSetupDialog = false;
  }

  async caseDisplayOrderUpdated(settings: UserSetting[]) {    
    // only refresh the matter data if order method is by service cost to recalculate the change of fee type
    const orderMethod = settings.filter(s => s.Name === UserSettingName.OrderingMethod && s.Value === OrderingMethod.ByServiceCost);    
    if(orderMethod.length > 0) {      

      const lineItem = await this.client.get<ManualCodeInvoiceLineItemDto[]>(`/api/manualcoding/${this.selectedMatterId}/line-items`)
      this.selectedMatter!.LineItems=lineItem;      
    }

    (this.$refs.matterWorkNavigation as any).refreshCaseDisplayOrder(settings);    
  }  

  selectColumns() {
    this.lineItemDataGrid.showColumnChooser();
    this.showingColumnChooser = true;
  }

  private changeFiling(dto: ChangeFilingTypeDto) {
    this.selectedMatter!.FilingTypeId = dto.FilingType;
    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.PhaseAnalysisItem)
  }

  private openNotes() {
    (this.$refs.matterWorkLineItems as any).openNotesKeyboard();    
  }

  private releaseMatters() {
    this.client.sendRequest(HttpMethodEnum.Post,
      `/api/matterworks/${this.matterWorkId}/release-matters`
    )
    .then(result => {
      this.closeReleaseMatters();
      this.$router.push({ name: 'coding-work' });
    });
  }

  private closeReleaseMatters() {
    this.showingReleaseMatters = false;
  }
}
